import { optimized, srcSetFor, pictureFor } from "../lib/img";

/* Responsive picture: AVIF first, WebP fallback, lazy below the fold. `display: contents` keeps the <img> exactly where a bare <img> sat, so layout and CSS do not change. */
export function Pic({ src, sizes = "100vw", alt = "", eager = false, className, imgRef, ...rest }) {
  const p = pictureFor(src);
  const loading = rest.loading || (eager ? "eager" : "lazy");
  const priority = rest.fetchPriority || (eager ? "high" : undefined);
  if (!p) return <img ref={imgRef} src={optimized(src)} srcSet={srcSetFor(src)} sizes={srcSetFor(src) ? sizes : undefined} alt={alt} className={className} decoding="async" {...rest} loading={loading} fetchPriority={priority} />;
  return (
    <picture className="contents">
      <source type="image/avif" srcSet={p.avif} sizes={sizes} />
      <img ref={imgRef} src={p.src} srcSet={p.webp} sizes={sizes} alt={alt} className={className} decoding="async" {...rest} loading={loading} fetchPriority={priority} />
    </picture>
  );
}
